import { configureStore} from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import logger from "redux-logger";
import storage from "redux-persist/lib/storage";
import rootReducer from "../rootreducer/rootReducer";

const persistConfig = {
  key: "myProjectKey1",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Avoid errors related to non-serializable values
    }).concat(logger),
  devTools: true,
});

export const persistor = persistStore(store);

export default store;
